import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseState } from './base.state';
import { MarkerGoogleMaps } from 'src/app/shared/models/maps/markerGoogleMaps';

@Injectable({
    providedIn: 'root',
})

export class MapsSate extends BaseState {

    override store = {
        loadingGetMarkers$: new BehaviorSubject<boolean>(false),
        markers$: new BehaviorSubject<MarkerGoogleMaps[]>([]),
        markersClustered$: new BehaviorSubject<MarkerGoogleMaps[]>([]),
    };

    constructor() {
        super();
    }

    isLoadingGetMarkers$() {
        return this.store.loadingGetMarkers$.asObservable();
    }

    setLoadingGetMarkers(isLoadingGetMarkers: boolean) {
        this.store.loadingGetMarkers$.next(isLoadingGetMarkers);
    }
    setMarkers(markers: MarkerGoogleMaps[]) {
        this.store.markers$.next(markers);
    }

    setMarkersClustered(markers: MarkerGoogleMaps[]) {
        this.store.markersClustered$.next(markers);
    }
    getMarkersClustered$(): Observable<MarkerGoogleMaps[]> {
        return this.store.markersClustered$.asObservable();
    }

    getClustersMembers(): MarkerGoogleMaps[]{
        return this.store.markersClustered$.getValue();
    }

    getMarkers$(): Observable<MarkerGoogleMaps[]> {
        return this.store.markers$.asObservable();
    }

    getMarkers(): MarkerGoogleMaps[] {
        return this.store.markers$.getValue();
    }

    addMarker(marker: Partial<MarkerGoogleMaps>) {
        console.log('addMarker()');
        this.add<Partial<MarkerGoogleMaps>>({ data: marker, storeRefAttribute: this.store.markers$ })
    }

    setVisibleMarker(id:number, value: boolean) {
        const currentState = this.store.markers$.getValue();
        currentState.forEach(m=>{
            if(m.id == id){m.visible = value}})
        this.store.markers$.next(currentState);
    }

    setVisibleAllMarkers(value:boolean){
        const currentState = this.store.markers$.getValue();
        currentState?.forEach(m=>{
          !!m ? m.visible = value : null})
        this.store.markers$.next(currentState);
    }

}
